import {Link} from "@nextui-org/react";

const data = {
    'mainCategory': 'Muối men cho đời',
    'subCategories': [
        'Tiếng Việt Online',
        'Muối Men Thời Sự',
        'Muối Men Lời Chúa',
        'Sách Nói Công Giáo',
        'Thánh Ca'
    ]
}

const color = ['bg-[#1C80DC]', 'bg-[#0AA3D3]', 'bg-[#E5310A]', 'bg-[#0FB21F]', 'bg-[#9747FF]', 'bg-[#42f5b9]', 'bg-[#f5ef42]', 'bg-[#eb8e1c]', 'bg-[#eb1ce8]', 'bg-[#eb1c8e]', "bg-[#0FB21F]"]

export default function Categories({categories, categoryCode}) {
    if (categories?.length === 0) {
        return <></>
    }

    const minLevel = categories.reduce((compare, e) => compare = Math.min(compare, e.level), Number.MAX_VALUE);
    const mainCategory = categories.find((e) => e.level === minLevel);
    const subCategories = categories.filter((e) => e.level > minLevel);

    return (
        <div className="border-1 shadow my-5 rounded-[5px] bg-white">
            <div className="flex bg-primary h-10 border-b-2 rounded-t-[5px]">
                <Link href={mainCategory.type === 'categories' ? `/chuyen-muc/${mainCategory.code}` : mainCategory.link} className="w-full font-bold text-lg text-white">
                    <span className="w-full text-center">
                        {mainCategory ? mainCategory.name.toUpperCase() : data.mainCategory.toUpperCase()}
                    </span>
                </Link>
            </div>

            <div>
                {/* TODO: ScrollShadow - Check active*/}
                {
                    subCategories.length !== 0 ?
                        subCategories.map((item, idx) => {
                            let isHighlight = categoryCode === item.code;
                            return (
                                <div key={idx}
                                    className={`flex justify-between items-center ${ isHighlight? 'bg-secondary' : ''}`}>
                                    <Link href={item.type === 'categories' ? `/chuyen-de/${item.code}` : item.link} className={ `h-10 pl-2`}>
                                        <span>{item.name}</span>
                                    </Link>
                                </div>
                            );
                        }) : null
                }
            </div>
        </div>
    );
}